import React, { Component } from 'react';

import classNames from 'classnames';
import { Button } from 'components/button';
import { I18n, translate } from 'components/translate';
import { commentDataProptype } from 'modules/community/commentList/DataPropType';
import PropTypes from 'prop-types';

import './CommentListAnswerBox.scss';

@translate()
export default class CommentListAnswerBox extends Component {
  static propTypes = {
    t: PropTypes.func,
    item: PropTypes.shape(commentDataProptype),
    answerListText: PropTypes.object,
    commentAnswerReply: PropTypes.func,
    closeAnswerBox: PropTypes.func,
    onAnswerText: PropTypes.func,
    isMobile: PropTypes.bool
  };

  state = {
    isLoading: false
  };

  get isLoading() {
    return this.state.isLoading;
  }

  get isSendDisabled() {
    const { answerListText, item } = this.props;

    return !answerListText[item.id]?.trim() || this.isLoading;
  }

  toggleLoading = () => this.setState({ isLoading: !this.isLoading });

  sendAnswer = async () => {
    const { item, commentAnswerReply } = this.props;

    if (commentAnswerReply) {
      this.toggleLoading();

      await commentAnswerReply(item);

      this.toggleLoading();
    }
  };

  cancel = () => {
    const { item, closeAnswerBox } = this.props;

    closeAnswerBox && closeAnswerBox(item);
  };

  render() {
    const { answerListText, onAnswerText, item, isMobile, t } = this.props;
    const loadingLabel = 'general.replying_with_dots';
    const answerLabel = 'general.answer';

    const sendButton = {
      label: this.isLoading ? loadingLabel : answerLabel,
      outline: isMobile,
      icon: !isMobile ? 'check' : ''
    };
    const cancelButton = {
      outline: !isMobile,
      type: isMobile ? 'cancel' : '',
      className: classNames(
        'comment-list__comment-cell__container__comment__buttons__cancel',
        {
          'comment-list__history__comment-detail__content__cancel-button':
            isMobile
        }
      )
    };
    const answerBoxClass = classNames({
      'comment-list__history__comment-detail__content__answer--margin': isMobile
    });

    return (
      <div className={answerBoxClass}>
        {isMobile && (
          <div className="comment-list__history__comment-detail__content__answer--opened">
            <I18n label="general.answer" />
          </div>
        )}
        <textarea
          className="comment-list__comment-cell__container__comment__answer-box"
          name={`answer-box-${item.id}`}
          onChange={(event) => onAnswerText(event, item)}
          value={answerListText[item.id]}
          placeholder={t('community.write_your_answer_input')}
        />
        <div className="comment-list__comment-cell__container__comment__buttons">
          <Button
            outline={sendButton.outline}
            size="small"
            disabled={this.isSendDisabled}
            onClick={this.sendAnswer}
          >
            <I18n label={sendButton.label} />
          </Button>

          <Button
            type={cancelButton.type}
            outline={cancelButton.outline}
            className={cancelButton.className}
            size="small"
            onClick={this.cancel}
          >
            <I18n label="general.cancel" />
          </Button>
        </div>

        {isMobile && (
          <hr className="comment-list__user-cell__container__divisor" />
        )}
      </div>
    );
  }
}
